import CrudCustom from '../../../libs/custom/CrudCustom';

let PegawaiService = new CrudCustom('/pegawais');
export default PegawaiService;
